import script from "./PromptForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptForm.vue?vue&type=script&setup=true&lang=js"

import "./PromptForm.vue?vue&type=style&index=0&id=f71100ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f71100ba"]])

export default __exports__